<template>
    <div class="container text-center px-3" style="margin-top:5rem;" :class="alto()" > <!--contenedor_cons_404   |   'height:'+height+'vh'  -->
        <img src="@/assets/imagenes/mantenimiento.png" class="imagen-404">
        <h1>Apartado en mantenimiento</h1>
        <h4 class="text-muted">Estamos trabajando para ofrecerle un mejor servicio</h4>
    </div>
</template>

<script>
export default {
    data: function(){
        return{
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    created(){
    },
    methods:{
        alto(){
            if((screen.width == 1024) && (screen.height == 1366)) return 'ipadPro12'
            if((screen.width == 1366) && (screen.height == 1024)) return 'grande' // a pesar de q este es ipadpro12 horizontal
            if(screen.width > 1900)  return 'grande'
            // if(screen.width > 1280)  return 'medio'
            else return 'medio'
        }
    }

}
</script>

<style scoped>
h1{
    font-size: 2.5rem;
    margin-bottom: 0;
    margin-top: 1rem;
    font-weight: 900;
}
h4 { margin-bottom: 3rem ;}
.imagen-404 { width: 30%; }

@media only screen and (max-device-width : 900px) {
    .imagen-404 { width: 100% !important; }
    h1{ font-size: 1.5rem; }
}


</style>
